if ( typeof ProductDescription !== 'function' ) {
		
	class ProductDescription extends HTMLElement {

		constructor(){
			super();
			this.init();
		}

		init(){

			this.description = this.querySelector('.product__description');

			if ( this.description.classList.contains('truncated') ) {

				this.descriptionInner = this.description.querySelector('.product__description-inner');

				if ( this.descriptionInner.offsetHeight - 10 > this.description.offsetHeight ) {
					this.descriptionTrigger = document.createElement('a');
					this.descriptionTrigger.classList.add('truncated__trigger');
					this.descriptionTrigger.setAttribute('tabindex', '0');
					this.descriptionTrigger.setAttribute('aria-controls', this.descriptionInner.id);
					this.descriptionTrigger.setAttribute('aria-expanded', false);
					this.descriptionTrigger.textContent = KROWN.settings.locales.product_more_description_label;
					this.description.after(this.descriptionTrigger);

					this.descriptionTrigger.addEventListener('click', this.onClickHandler.bind(this));
					this.descriptionTrigger.addEventListener('keydown', (e) => {
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							this.onClickHandler(e);
						}
					})

				} 
				else {
					// hide the bottom fade gradient if nothing to truncate
					this.description.classList.remove('truncated')
				}
				
			}

		}

		onClickHandler(e) {
			e.preventDefault();
			if ( ! this.description.classList.contains('truncated--show') ) {
				this.description.classList.add('truncated--show');
				this.description.style.maxHeight = this.descriptionInner.offsetHeight + 'px';
				this.descriptionTrigger.textContent = KROWN.settings.locales.product_less_description_label;
				this.descriptionTrigger.setAttribute('aria-expanded', true);
				this.descriptionInner.setAttribute('tabIndex', '0');
			} else {
				this.description.classList.remove('truncated--show');
				this.description.setAttribute('style', '');
				this.descriptionTrigger.textContent = KROWN.settings.locales.product_more_description_label;
				this.descriptionTrigger.setAttribute('aria-expanded', false);
			}
		}

	}

	if ( typeof customElements.get('product-description') == 'undefined' ) {
		customElements.define('product-description', ProductDescription);
	}

}

if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('.product-gallery');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

				this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
					if ( i == 0 )
						elm.classList.add('active');
					elm.addEventListener('click',e=>{
						if ( this.productSlider.sliderEnabled ) {
							this.productSlider.changeSlide(e.currentTarget.dataset.index);
						} else {
							window.scrollTo({
								top: this.productGallery.querySelector(`.product-gallery__item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
								behavior: 'smooth'
							});
							this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
						}
						this._pauseAllMedia();
						this._playMedia(this.productGallery.querySelector(`.product-gallery__item[data-index="${e.currentTarget.dataset.index}"]`));
					});
				})

				this.productSlider.addEventListener('change', e=>{
					this.thumbnailNavigationHelper(e.target.index);
				});

			}

			// Desktop thumbnail controls and shared active-thumbnail follow on all screen sizes.
			const thumbnailsHolder = this.querySelector('.thumbnails-holder');
			if (thumbnailsHolder && this.productGallery.classList.contains('product-gallery--slider')) {
				const strip = thumbnailsHolder.closest('.product-gallery__thumbnails');
				const desktop = window.matchMedia('(min-width: 1024px)');
				const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
				const originalHidden = strip.getAttribute('aria-hidden');
				strip.classList.add('mv21-thumbnail-controls');

				const locale = document.documentElement.lang.split('-')[0];
				const labels = {lv: ['Iepriekšējie attēli', 'Nākamie attēli'], lt: ['Ankstesni vaizdai', 'Kiti vaizdai'], et: ['Eelmised pildid', 'Järgmised pildid'], en: ['Previous images', 'Next images']}[locale] || ['Previous images', 'Next images'];
				const arrows = [-1, 1].map((direction, i) => {
					const button = document.createElement('button');
					button.type = 'button';
					button.className = 'mv21-thumb-arrow ' + (direction < 0 ? 'mv21-thumb-prev' : 'mv21-thumb-next');
					button.setAttribute('aria-label', labels[i]);
					button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="' + (direction < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
					button.addEventListener('click', () => thumbnailsHolder.scrollBy({left: direction * Math.max(80, thumbnailsHolder.clientWidth * .8), behavior: reducedMotion.matches ? 'auto' : 'smooth'}));
					strip.appendChild(button);
					return button;
				});
				const updateArrows = () => {
					const maxScroll = thumbnailsHolder.scrollWidth - thumbnailsHolder.clientWidth;
					arrows[0].disabled = thumbnailsHolder.scrollLeft <= 2;
					arrows[1].disabled = thumbnailsHolder.scrollLeft >= maxScroll - 2;
				};
				const updateLayout = () => {
					if (!this.isConnected) return;
					const available = strip.clientWidth;
					const content = thumbnailsHolder.querySelector('.thumbnails');
					strip.classList.toggle('mv21-thumbs-overflow', desktop.matches && content && content.scrollWidth > available + 2);
					if (desktop.matches) strip.removeAttribute('aria-hidden');
					else if (originalHidden !== null) strip.setAttribute('aria-hidden', originalHidden);
					updateArrows();
				};
				thumbnailsHolder.addEventListener('scroll', updateArrows, {passive: true});
				const resizeObserver = new ResizeObserver(updateLayout);
				resizeObserver.observe(strip);
				if (thumbnailsHolder.firstElementChild) resizeObserver.observe(thumbnailsHolder.firstElementChild);
				desktop.addEventListener('change', updateLayout);
				requestAnimationFrame(updateLayout);
				let isDown = false, dragMoved = false, startX = 0, scrollStart = 0;
				thumbnailsHolder.addEventListener('dragstart', e => { if (desktop.matches) e.preventDefault(); });
				thumbnailsHolder.addEventListener('pointerdown', e => {
					if (!desktop.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
					isDown = true; dragMoved = false; startX = e.clientX; scrollStart = thumbnailsHolder.scrollLeft;
				});
				thumbnailsHolder.addEventListener('pointermove', e => {
					if (!isDown) return;
					const distance = e.clientX - startX;
					if (Math.abs(distance) > 5) {
						dragMoved = true;
						thumbnailsHolder.setPointerCapture(e.pointerId);
						thumbnailsHolder.classList.add('dragging');
					}
					if (dragMoved) { e.preventDefault(); thumbnailsHolder.scrollLeft = scrollStart - distance; }
				});
				const endDrag = () => { isDown = false; thumbnailsHolder.classList.remove('dragging'); };
				['pointerup', 'pointercancel', 'lostpointercapture', 'pointerleave'].forEach(name => thumbnailsHolder.addEventListener(name, endDrag));
				thumbnailsHolder.addEventListener('click', e => {
					if (dragMoved && e.detail !== 0) { e.preventDefault(); e.stopPropagation(); }
					dragMoved = false;
				}, true);
				this.productSlider.addEventListener('change', () => {
					if (isDown) return;
					requestAnimationFrame(() => {
						const active = thumbnailsHolder.querySelector('.thumbnail.active');
						if (!active) return;
						const item = active.getBoundingClientRect(), holder = thumbnailsHolder.getBoundingClientRect();
						const delta = item.left < holder.left ? item.left - holder.left : item.right > holder.right ? item.right - holder.right : 0;
						if (delta) thumbnailsHolder.scrollBy({left: delta, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
					});
				});
			}

			this.productSlider.addEventListener('navigation', e=>{
				this._playMedia(this.productGallery.querySelector(`.product-gallery__item[data-index="${e.target.index}"]`));
			})
			this.productSlider.addEventListener('change', e=>{
				if ( this.productGallery.querySelector(`.product-gallery__item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' && this.xrButton ) {
					this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery__item[data-index="${e.target.index}"]`).dataset.mediaId);
				}
				this._pauseAllMedia();
				this.thumbnailNavigationHelper(e.target.index);
			});

			// Product variant event listener for theme specific logic

			const productVariants = this.querySelector('product-variants');
			if ( productVariants ) {
				productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:productVariants});
			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('.product__add-to-cart') ) {
					this.querySelector('.product__add-to-cart').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('.product__form') ) {
					this.querySelector('.product__form').addEventListener('add-to-cart', ()=>{
						document.querySelector('.sidebar__cart').show();
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('.sidebar__cart .sidebar__cart-close').focus();
							}, 200);
						}
					});
				}

			}

			// Gallery resize helper

			this.GALLERY_RESIZE_EVENT = debounce(()=>{
				ProductGalleryResizeHelper(this.productGallery);
			}, 100);
			window.addEventListener('resize', this.GALLERY_RESIZE_EVENT, {passive:true});

			// Scroll navigation helper 

			if ( this.productGallery.classList.contains('product-gallery--scroll') ) {

				this.productGalleryNavigation = this.querySelector('.product-gallery__thumbnails');
				this.productGalleryNavigationItem = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');

				const productGallerySlides = this.productGallery.querySelectorAll('.product-gallery__item');
				const reversedGallerySlides = [...productGallerySlides].reverse();

				this.GALLERY_NAVIGATION_SCROLL = ()=>{

					if ( ! this.productGallery.querySelector('css-slider').sliderEnabled && window.innerWidth > 1023 ) {

						for ( const slide of reversedGallerySlides ) {
							const slideTop = slide.getBoundingClientRect().top;
							if ( slideTop < window.innerHeight / 2 && slideTop > -window.innerHeight / 2  ) {
								this.productGalleryNavigationItem.forEach(elm=>elm.classList.remove('active'));
								this.productGalleryNavigationItem[slide.dataset.index].classList.add('active');
								break;
							} 
						}

						const productGalleryTop = this.productGallery.getBoundingClientRect().top

						if ( (productGalleryTop - window.innerHeight) * -1 > this.productGallery.offsetHeight ) {
							this.productGalleryNavigation.classList.add('scroll');
						} else if ( productGalleryTop > 0 ) {
								this.productGalleryNavigation.classList.add('scroll-up');
							this.productGalleryNavigation.classList.add('scroll');
						} else if ( (productGalleryTop - window.innerHeight) * -1 < this.productGallery.offsetHeight ) {
							this.productGalleryNavigation.classList.remove('scroll');
							this.productGalleryNavigation.classList.remove('scroll-up');
						}

					}

				}

				window.addEventListener('scroll', this.GALLERY_NAVIGATION_SCROLL, {passive:true});
				this.GALLERY_NAVIGATION_SCROLL();

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('.product__add-to-cart');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(mutations=>{
					for ( const mutation of mutations ) {
						if ( addToCartButton.classList.contains('disabled') ) {
							this.querySelector('product-form').classList.add('disable-buy-button');
						} else {
							this.querySelector('product-form').classList.remove('disable-buy-button');
						}
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// complementary products
			if ( this.querySelector('product-recommendations') ) {
				this.querySelector('product-recommendations').addEventListener('product-recommendations-loaded',e=>{
				})
			}

		}

		thumbnailNavigationHelper(index=0){ 
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				elm.setAttribute('aria-current', i == index ? 'true' : 'false');
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){
			// A single-media gallery has no slider pages to navigate.
			if (!this.productGallery || this.productGallery.querySelectorAll('.product-gallery__item').length < 2) return;
			let variant = e.target.currentVariant;
			if ( variant && variant.featured_media != null ) {
				let variantImg = this.productGallery.querySelector('.product-gallery__item[data-media-id="' + variant.featured_media.id + '"]');
				if ( variantImg ) {
					if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
						if ( this.productGallery.querySelector('css-slider').sliderEnabled ) {
							this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
						}
					} else {
						window.scrollTo({
							top: variantImg.offsetTop,
							behavior: 'smooth'
						});
					}
				}
			}
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

/* One-click variant buttons: sync with hidden select and selected state */
(function() {
	function syncVariantButtonsSelected(productVariantsEl) {
		if ( ! productVariantsEl ) return;
		productVariantsEl.querySelectorAll('.product-variant').forEach(function(row) {
			var select = row.querySelector('.product-variant-dropdown select');
			var buttons = row.querySelectorAll('.product-variant-button');
			if ( ! select || ! buttons.length ) return;
			var selectedValue = select.value;
			var options = select.querySelectorAll('option');
			buttons.forEach(function(btn) {
				var val = btn.getAttribute('data-value');
				var isSelected = val === selectedValue;
				btn.classList.toggle('selected', isSelected);
				if ( isSelected ) btn.setAttribute('data-selected', ''); else btn.removeAttribute('data-selected');
				var opt = Array.prototype.find.call(options, function(o) { return o.value === val; });
				if ( opt ) {
					btn.classList.toggle('disabled', !!(opt.disabled || opt.classList.contains('disabled')));
				}
			});
		});
	}

	function initVariantButtons() {
		document.querySelectorAll('product-variants').forEach(function(productVariantsEl) {
			syncVariantButtonsSelected(productVariantsEl);
			productVariantsEl.addEventListener('click', function(e) {
				var btn = e.target.closest('.product-variant-button');
				if ( ! btn || btn.disabled ) return;
				var row = btn.closest('.product-variant');
				var select = row.querySelector('.product-variant-dropdown select');
				if ( ! select ) return;
				select.value = btn.getAttribute('data-value');
				select.dispatchEvent(new Event('change', { bubbles: true }));
				row.querySelectorAll('.product-variant-button').forEach(function(b) {
					b.classList.remove('selected');
					b.removeAttribute('data-selected');
				});
				btn.classList.add('selected');
				btn.setAttribute('data-selected', '');
			});
		});
		document.addEventListener('krown:variant:change', function() {
			document.querySelectorAll('product-variants').forEach(syncVariantButtonsSelected);
		});
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', initVariantButtons);
	} else {
		initVariantButtons();
	}
	document.addEventListener('shopify:section:load', initVariantButtons);
})();
/* Compact, sticky desktop gallery. Mobile gallery remains theme-managed. */
(function () {
  function init(root) {
    root.querySelectorAll('.main-product .product__gallery').forEach(function (panel) {
      if (panel.dataset.mv21CompactReady) return;
      panel.dataset.mv21CompactReady = 'true';
      var gallery = panel.querySelector('.product-gallery--slider');
      if (!gallery) return;
      panel.classList.add('mv21-compact-gallery');
      document.body.classList.add('mv21-sticky-product-page');
      var desktop = window.matchMedia('(min-width: 1024px)');
      function size() {
        if (!desktop.matches || !panel.isConnected) return;
        // Stable display area across landscape, portrait and video slides.
        var height = Math.round(Math.min(Math.max(380, gallery.clientWidth * 0.85), 640, Math.max(200, window.innerHeight - 180)));
        var value = height + 'px';
        if (panel.style.getPropertyValue('--mv21-stage-height') !== value) panel.style.setProperty('--mv21-stage-height', value);
      }
      var observer = new ResizeObserver(size);
      observer.observe(gallery);
      gallery.addEventListener('change', function () { requestAnimationFrame(size); });
      window.addEventListener('resize', size, {passive: true});
      desktop.addEventListener('change', size);
      size();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function () { init(document); });
})();

/* Supply an accessible name only when the Inbank app has not provided one. */
(function () {
  var names = {lv:'Informācija par maksājumu pa daļām',lt:'Informacija apie mokėjimą dalimis',et:'Teave osamaksete kohta',en:'Information about instalment payments'};
  var label = names[document.documentElement.lang.split('-')[0]] || names.en;
  function nameButtons(root) {
    var buttons = root.matches && root.matches('.ib-calculator-popover__button') ? [root] : root.querySelectorAll('.ib-calculator-popover__button');
    buttons.forEach(function (button) {
      if ((button.getAttribute('aria-label') || '').trim() || button.textContent.trim()) return;
      var ids = (button.getAttribute('aria-labelledby') || '').trim().split(/\s+/);
      if (ids.some(function (id) { var node = document.getElementById(id); return node && node.textContent.trim(); })) return;
      button.removeAttribute('aria-labelledby');
      button.setAttribute('aria-label', label);
    });
  }
  function init(root) {
    root.querySelectorAll('.main-product .product__text').forEach(function (panel) {
      if (panel.dataset.m21InbankA11y) return;
      panel.dataset.m21InbankA11y = 'true';
      nameButtons(panel);
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) nameButtons(node); }); });
        if (!panel.isConnected) observer.disconnect();
      });
      observer.observe(panel, {childList:true, subtree:true});
      window.addEventListener('pagehide', function () { observer.disconnect(); delete panel.dataset.m21InbankA11y; }, {once:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once:true});
  else init(document);
  window.addEventListener('pageshow', function () { init(document); });
  document.addEventListener('shopify:section:load', function () { init(document); });
})();
